import ProgressBar from "svg-progress-bar";
import {cssVar} from "../helpers/tools";

const defaultConfig = {
  radius: 80,
  varyStrokeArray: [15, 25],
  pathColors: ['#FFF', cssVar("--success", '#AACE32')],
  text: function (value) {
    return this.htmlifyNumber(value) + '%';
  },
  textColor: '#FFF'
};

export default {
  name: "progress-bar",
  props: ['value', 'options'],

  /**
   *
   * @param h
   * @returns {*}
   */
  render (h) {
    return (
      <ProgressBar value={this.value} options={this.options || defaultConfig}/>
    );
  }
};
